import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3209c464&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3209c464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3209c464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3209c464')) {
      api.createRecord('3209c464', component.options)
    } else {
      api.reload('3209c464', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3209c464&scoped=true&", function () {
      api.rerender('3209c464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/FormActionBtns/index.vue"
export default component.exports